module.exports = __webpack_public_path__ + "assets/img/banner2.f55de7c5.png";